import styled, { css } from "styled-components";

import { CSSGridTemplate } from "@components/Layout/CSSGridTemplate";

import { sortByPriority } from "@services/SortByPriority";

import { getMaxColumns } from "./CSSGrid.helpers";
import type { Breakpoint, RowGap, TemplateRows } from "./CSSGrid.types";

const breakpoints: Breakpoint[] = [
  "all",
  "largeMobile",
  "smallTablet",
  "tablet",
  "smallDesktop",
  "desktop",
  "largeDesktop",
];

const gridTemplateColumns = css`
  ${({ theme }) => {
    const styles = breakpoints.reduce((acc, breakpoint: Breakpoint) => {
      let style = `grid-template-columns: repeat(${getMaxColumns(
        breakpoint,
      )}, minmax(0, 1fr));`;

      if (breakpoint !== "all") {
        style = `${theme.breakpointsV2[breakpoint]} {${style}}`;
      }

      return acc + "\n" + style;
    }, "");
    return styles;
  }}
`;

export const Root = styled(CSSGridTemplate)<{
  $rowGap?: RowGap;
  $templateRows?: TemplateRows;
}>`
  ${gridTemplateColumns}

  grid-column-gap: ${({ theme }) => theme.spacing.spacing_24};
  grid-template-rows: auto;

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    grid-column-gap: ${({ theme }) => theme.spacing.spacing_32};
  }

  ${({ $rowGap }) =>
    typeof $rowGap !== "object" &&
    css`
      row-gap: ${$rowGap};
    `}
  ${({ $rowGap, theme }) =>
    typeof $rowGap === "object" &&
    Object.keys($rowGap)
      .sort(sortByPriority())
      .map((breakpoint: keyof RowGap) => {
        if (breakpoint === "default") {
          return css`
            row-gap: ${$rowGap[breakpoint]};
          `;
        }

        return css`
          ${theme.breakpointsV2[breakpoint]} {
            row-gap: ${$rowGap[breakpoint]};
          }
        `;
      })}

  ${({ $templateRows }) =>
    typeof $templateRows !== "object" &&
    css`
      grid-template-rows: ${$templateRows};
    `}
  ${({ $templateRows, theme }) =>
    typeof $templateRows === "object" &&
    Object.keys($templateRows)
      .sort(sortByPriority())
      .map((breakpoint: keyof RowGap) => {
        if (breakpoint === "default") {
          return css`
            grid-template-rows: ${$templateRows[breakpoint]};
          `;
        }

        return css`
          ${theme.breakpointsV2[breakpoint]} {
            grid-template-rows: ${$templateRows[breakpoint]};
          }
        `;
      })}
`;
